import { Typography } from '@material-ui/core';
import { Inline, Stack } from '@superdispatch/ui';
import { ReactElement } from 'react';
import { EmptySearchLoadsIcon } from 'shared/icons/EmptySearchLoadsIcon';
import { getActiveSearchCount } from 'shared/modules/loadboard/PostingSearchCriteriaDTO';
import styled from 'styled-components';
import { usePostingsPageContext } from '../../core/postings/PostingsPageContext';
import { SimilarLoads } from '../../core/similar-loads/SimilarLoads';
import { isEmptyCriteria } from '../../data/dto/PostingsPageParamsDTO';
import { PostingListCard } from './PostingListCard';
import { PostingListEmptyBooking } from '../../core/postings/PostingListEmptyBooking';
import { PrivatePostingListEmpty } from './PrivatePostingListEmpty';

const Styled1 = styled.div`
  flex: 1;
  padding: 32px 16px;
`;

export function PostingListEmpty(): ReactElement {
  const { params } = usePostingsPageContext();

  if (
    params.current_tab === 'private-loadboard' &&
    getActiveSearchCount(params.search_criteria) === 0
  ) {
    return <PrivatePostingListEmpty />;
  }

  return (
    <Styled1>
      <Stack space="small">
        <Inline horizontalAlign="center">
          <EmptySearchLoadsIcon />
        </Inline>

        {params.current_saved_search_guid ? (
          <Typography align="center" variant="h3">
            No loads match selected load alert
          </Typography>
        ) : params.search_criteria.show_bookable ? (
          <PostingListEmptyBooking />
        ) : !isEmptyCriteria(params) ? (
          <Typography variant="h3" align="center">
            No loads match search criteria
          </Typography>
        ) : (
          <Typography align="center" variant="h3">
            No {params.current_tab} loads
          </Typography>
        )}
      </Stack>

      {!isEmptyCriteria(params) && (
        <SimilarLoads
          existingPostings={[]}
          renderLoadCard={(posting) => (
            <PostingListCard posting={posting} source="Similar Loads" />
          )}
        />
      )}
    </Styled1>
  );
}
